export default "__VITE_ASSET__0cb13493__"